import type { JsonEditorCommand } from "src/data/commands";

import type { Device } from "@dashboard/devices/types";
import { getMinimumEmteriaUpdateVersionCodeAcrossDevices } from "@services/deviceCommandPreparation/commandService";
import { supportsEmteriaUpdateService } from "@services/deviceCommandPreparation/startOsUpdateCommand";

export { prepareCommandPayload } from "@services/deviceCommandPreparation/commandService";

const transformStartOsUpdateCommand = (command: JsonEditorCommand, effectiveVersionCode: number | null): JsonEditorCommand => {
    const shouldHideDownloadAndInstall = effectiveVersionCode !== null && !supportsEmteriaUpdateService(effectiveVersionCode);

    if (!shouldHideDownloadAndInstall) {
        return command;
    }

    const cloned = structuredClone(command) as JsonEditorCommand;
    const actionProp = cloned.schema.properties?.action as { enum?: string[]; options?: { enum_titles?: string[] } } | undefined;
    if (actionProp?.enum) {
        actionProp.enum = ["installLatest"];
        const titles = actionProp.options?.enum_titles;
        if (titles?.length) {
            actionProp.options = { ...actionProp.options, enum_titles: [titles[0]] };
        }
    }
    return cloned;
};

export const buildExamplesCommandsList = (commands: JsonEditorCommand[], devices: Device[]): JsonEditorCommand[] => {
    const effectiveVersionCode = getMinimumEmteriaUpdateVersionCodeAcrossDevices(devices);

    return commands.map((cmd) => {
        if (cmd.name === "startOsUpdate") {
            return transformStartOsUpdateCommand(cmd, effectiveVersionCode ?? null);
        }
        return cmd;
    });
};
